import React from 'react';
import LoginForm from './LoginForm';
import BrainDiagram from '../BrainDiagram';
import FooterLogo from '../FooterLogo';
import CopyRight from '../CopyRight';

function Login() {
  return (
    <section className="login-page">
      <div className="container-fluid pd-80  pt-md-0 pt-4 pb-md-0 pb-4">
        <div className="row align-items-center flex-column flex-md-row-reverse flex-lg-row-reverse">
          <div className="col-xl-3 col-lg-3 col-md-12 col-12 d-inline-block align-self-end order-3">
            <FooterLogo />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-6 col-12 order-2">
            <BrainDiagram />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 col-12 order-1">
            <LoginForm />
          </div>
        </div>
        <CopyRight />
      </div>
    </section>
  );
}

export default Login;